import React from 'react';
import MapShowRows from './MapShowRows';
import PidShowRows from './PidShowRows';

interface ShowTablesProps {
  attributes: Array<any>;
  dataAttributeValueMap: Map<string, any>;
  chooseComponent?: (attribute: any, dataAttributeValueMap: Map<string, any>) => React.ReactNode;
  InputRows?: React.ComponentType<{
    attributes: Array<any>;
    dataAttributeValueMap: Map<string, any>;
  }>;
  RenderRow?: (attribute: any, dataAttributeValueMap: Map<string, any>, areaId?: number) => React.ReactNode;
}

const ShowTables: React.FC<ShowTablesProps> = ({
  attributes,
  dataAttributeValueMap,
  chooseComponent,
  InputRows,
  RenderRow
}) => {
  return (
    <>
      <div className="map-area-box">
        <table
          className="uk-table uk-table-small"
          style={{ marginTop: 0, borderCollapse: 'collapse', verticalAlign: 'top' }}
        >
          <tbody>
            {InputRows && (
                <InputRows
                    attributes={attributes}
                    dataAttributeValueMap={dataAttributeValueMap}
                />
            )}
          </tbody>
        </table>

        <table
          className="uk-table uk-table-small"
          style={{ marginTop: 0, borderCollapse: 'collapse', verticalAlign: 'top' }}
        >
          <tbody>
            {MapShowRows && (
                <MapShowRows
                  attributes={attributes}
                  dataAttributeValueMap={dataAttributeValueMap}
                  chooseComponent={chooseComponent}
                />
            )}
          </tbody>
        </table>
      </div>

      <table
        className="uk-table uk-table-small"
        style={{ borderCollapse: 'collapse' }}
      >
        <tbody>
          <PidShowRows
            attributes={attributes}
            dataAttributeValueMap={dataAttributeValueMap}
            RenderRow={RenderRow}
          />
        </tbody>
      </table>
    </>
  );
};

export default ShowTables;
